module.exports = __webpack_public_path__ + "static/media/33_plantilla_rec_combo_simple_cf_gaseosas_pet_2_5_ccsa_y_csso.475c7a19.png";